{
  "data": [
    "AccountConnection",
    "AccountHookConnection",
    "ActiveSubscribersConnection",
    "AllContentItemsForAccountConnection",
    "AnonymousCommentsForMediaConnection",
    "AnonymousMediaGroupsForProjectConnection",
    "AnonymousMediasForMediaGroupConnection",
    "AnonymousMediasForProjectConnection",
    "AnonymousTeamCommentsForMediaConnection",
    "ArchivedItemConnection",
    "AudienceConnection",
    "AudioConnection",
    "BandwidthOptionProductConnection",
    "BrandKitsForAccountConnection",
    "ChannelConnection",
    "ChannelEpisodesConnection",
    "ChannelRolesConnection",
    "ChannelRolesForContactConnection",
    "ChannelsForAccountConnection",
    "ChannelsWithAdminPermissionsConnection",
    "CollaborativeConnection",
    "CommentsForMediaConnection",
    "ContactConnection",
    "ContainersWithAdminPermissionsConnection",
    "DownloadableMediaFilesForMediaConnection",
    "DubbingOptionProductConnection",
    "EditExportConnection",
    "EditExportsConnection",
    "EditImportsConnection",
    "EditSessionConnection",
    "EncodingOptionProductConnection",
    "EpisodesForSectionConnection",
    "EventConnection",
    "ExternalLibraryFileConnection",
    "ExternalMigrationRequestConnection",
    "IncludedUserProductConnection",
    "LiveStreamEventConnection",
    "LiveStreamEventRolesConnection",
    "LiveStreamEventsForAccountConnection",
    "MediaGroupsForProjectConnection",
    "MediaOptionProductConnection",
    "MediaRequestsForAccountConnection",
    "MediasForAccountConnection",
    "MediasForChannelConnection",
    "MediasForContactConnection",
    "MediasForMediaGroupConnection",
    "MediasForProjectConnection",
    "MediasForRecordingSessionConnection",
    "OnboardingActivityConnection",
    "OrderConnection",
    "PodcastFileImportConnection",
    "PodcastImportRequestConnection",
    "ProjectAuthorizedContactConnection",
    "ProjectConnection",
    "ProjectsWithAdminPermissionsConnection",
    "PublicProfileConnection",
    "RecordingSessionConnection",
    "RegistrationConnection",
    "SectionsForChannelConnection",
    "SharingsConnection",
    "SpeedyEncodingOptionProductConnection",
    "StorageOptionProductConnection",
    "TagConnection",
    "TeamCommentsForMediaConnection",
    "TextTranslationOptionProductConnection",
    "TranscriptionOptionProductConnection",
    "VideoConnection",
    "WorkspaceOptionProductConnection",
    "WorkspacesConnection"
  ]
}